import store from '../../../store/store'

import('./title.css')

export default function Title(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this
    let station

    this.generate = () =>{
        
    }

    this.setStation = s =>{
        station = s
        this.update()
    }

    this.update = () =>{
        let title = Array.isArray(station) ?  store.informationCardStore.getTitle() :  `${station.prefix} - ${station.station.name.toUpperCase()}`
        elements.title.innerHTML = title
    }

    init()
    
    function init(){
        elements.title = context.createElement('div','modal-measurements-title','')
        elements.subtitle = context.createElement('div','modal-measurements-subtitle','')

        $(container).append(elements.title, elements.subtitle)
    }
}

Title.prototype = Object.create(BaseConstructor.prototype)